import { ALERT_NOTIFICATIONS } from "constants/app";

export const APP_ENV_MODE = (typeof APP_ENV !== "undefined" && APP_ENV) || process.env.APP_ENV || "LIB";
export const ENV_FLAGS = process.env.ENV_FLAGS;

export const FETCH_ABORT_ERROR = "AbortError";
export const ENV_CONFIG_LOAD_ERROR = "Error: Failed to fetch environment config";

export const NOTIFICATION_TIMEOUT = 15;
export const INITIAL_FIELD_VALUE = { value: "", errors: [], touched: false };

export const ATB_APPLICATION_BASENAME = "/business/thanksforbusiness";

export const LOB = {
  ATB: "ATB",
  DATA: "DATA",
  NXTRA: "NXTRA",
  MOBILITY: "MOBILITY",
  BLUEJEANS: "BLUEJEANS",
  TELEMEDIA: "TELEMEDIA",
  GUEST_DASHBOARD: "GUEST_DASHBOARD",
  AIRTELIQ: "AIRTELIQ",
  SECOPS: "SECOPS",
  AIRTEL_CLOUD: "AIRTEL_CLOUD",
  CYBER_SECURITY: "CYBER_SECURITY",
};

export const LOB_URL_MAP = {
  [LOB.MOBILITY]: "mobility",
  [LOB.DATA]: "data",
  [LOB.NXTRA]: "nxtra",
  [LOB.BLUEJEANS]: "bluejeans",
  [LOB.TELEMEDIA]: "internet",
  [LOB.GUEST_DASHBOARD]: "guest",
  [LOB.AIRTELIQ]: "airteliq",
  [LOB.SECOPS]: "secops",
  [LOB.AIRTEL_CLOUD]: "airtel-cloud",
  [LOB.CYBER_SECURITY]: "cyber-security"
};

export const LOB_INVENTORY_ROUTE_MAP = {
  [LOB.DATA]: "circuits",
  [LOB.MOBILITY]: "connections",
  [LOB.TELEMEDIA]: "connections",
  [LOB.NXTRA]: "services",
  [LOB.AIRTELIQ]: "services",
  [LOB.SECOPS]: "services",
  [LOB.AIRTEL_CLOUD]: "tenants",
  [LOB.CYBER_SECURITY]: "services",
};
export const LOB_NAME = {
  DATA: "Airtel Connectivity",
  MOBILITY: "Airtel Mobile",
  NXTRA: "Nxtra By Airtel",
  BLUEJEANS: "Airtel BlueJeans",
  TELEMEDIA: "Airtel Landline",
  AIRTELIQ: "Airtel IQ",
  SECOPS: "Secops",
  AIRTEL_CLOUD: "Airtel Cloud",
  CYBER_SECURITY: "Cyber Security",
};

export const LOB_ROUTES = {
  [LOB.MOBILITY]: "mobility",
  [LOB.DATA]: "data",
  [LOB.NXTRA]: "nxtra",
  [LOB.BLUEJEANS]: "bluejeans",
  [LOB.TELEMEDIA]: "internet",
  [LOB.AIRTELIQ]: "airteliq",
  [LOB.SECOPS]: "secops",
  [LOB.AIRTEL_CLOUD]: "airtel-cloud",
  [LOB.CYBER_SECURITY]: "cyber-security",
};

export const PARTY_AGGREGATION_LEVEL = {
  EMAIL: "EMAIL",
  LOB: "LOB",
  PRODUCT: "PRODUCT",
  PARTY: "PARTY",
};

export const KEY = {
  ENTER: {
    keyCode: 13,
    keyName: "Enter",
  },
  ESCAPE: {
    keyCode: 27,
    keyName: "Escape",
  },
  FORWARD_SLASH: {
    keyCode: 191,
    keyName: "/",
  },
  ARROW_UP: {
    keyCode: 38,
    keyName: "ArrowUp",
  },
  ARROW_DOWN: {
    keyCode: 40,
    keyName: "ArrowDown",
  },
};

export const VALIDATIONS = {
  NUMERIC: /^[0-9]*$/,
};

export const API_FETCH_STATUS = {
  LOADING: "loading",
  SUCCESS: "hasValue",
  ERROR: "hasError",
};

export const CONTACT_TYPES = {
  ACCOUNT_MANAGER: "AM",
  VRM_TL: "VRM_TL",
};

export const COMPANY_SEGMENT_TYPES = {
  SMALL: "SMALL",
  MEDIUM: "MEDIUM",
  LARGE: "LARGE",
};

const { TYPE } = ALERT_NOTIFICATIONS;

export const ALERT_TYPES_TO_CLASSNAMES = {
  [TYPE.default]: "",
  [TYPE.info]: "_light",
  [TYPE.success]: "_success",
  [TYPE.error]: "_error",
  [TYPE.warning]: "_warning",
};

export const APPLICATIONS = {
  AIRTEL_WORK: "AirtelWork",
  BROWSER: "BROWSER",
};

export const LIB_CONSUMER = {
  ATB: "ATB",
  NOT_ATB: "NOT_ATB",
};

export const LINK_TO_ROUTE = {
  DASHBOARD: "/selfcare/:lob?/dashboard",
  MANAGE_ACCOUNT: "/selfcare/:lob?/user",
  CHANGE_PASSWORD: "/selfcare/:lob?/user/change-password",
  USER_ACTIVITY: "/selfcare/:lob?/user/activity",
  USER_PROFILE: "/selfcare/:lob?/user/profile",
  PAYMENT_HISTORY: "/selfcare/:lob?/billing/payment",
  BILL_PAY_AND_DOWNLOAD: "/selfcare/:lob?/billing/pay-and-download/",
  NEFT_PAYMENT: "/selfcare/:lob?/billing/declare",
  VAN_PAYMENT: "/selfcare/:lob?/billing/allocate",
  SR_RAISE: "/selfcare/:lob?/sr/raise/",
  SR_DASHBOARD: "/selfcare/:lob?/sr/dashboard",
  SR_TRACK: "/selfcare/:lob?/sr/track",
  PRODUCT_DASHBOARD: "/selfcare/:lob/:product?/:inventoryRoute/dashboard",
  GETTING_STARTING: "/selfcare/help/lob/lob_enterprisehub#category_enterprisehub_level1_gettingstarted",
  TRACK_ORDER: "/selfcare/:lob?/track-orders",
  HELP: "/selfcare/help/",
  GETTING_STARTING: "/selfcare/help/lob/lob_enterprisehub#category_enterprisehub_level1_gettingstarted",
  SR_RAISE: "/selfcare/:lob?/sr/raise/",
  ALL_NOTIFICATION: "/selfcare/:lob?/all-notifications",
  ACCOUNT_CONTACTS: "/selfcare/:lob?/user/account-contacts",
  USERS_PERMISSIONS: "/selfcare/:lob?/user/manage",
};

export const DEFAULT_DATE_FORMAT = "DD MMM YYYY";

export const PROFILE_TYPES = {
  ATB_SECONDARY_KAM_USER: "ATB_SECONDARY_KAM_USER",
};